<template>
  <div>
    <SOSlotBase :is-search="false" :bg-grey="false" :loading="isFetching">
      <template v-slot:loading-page>
        <SOLoadingPage />
      </template>

      <template v-slot:title-bar>
        <SOTitleBar :page-title="'Detail Penghapusan'" :type="'back'" @back="back" />
      </template>

      <template v-slot:content>
        <div class="detail_content col-md-12 col-sm-12 col-12">
          <div class="header_detail  m-t-16">
            <label v-if="!isConfirmed" class="f-12 f-regular fc-yellow d-block mb-0">
              Penghapusan
            </label>
            <label class="f-18 f-bold f-c-black d-block">Hapus transaksi dari Outlet {{ data.nama_outlet }}</label>
            <label class="d-block f-c-midgrey f-14 f-regular">
              <img src="@/assets/icons/clock.svg" class="pb-1" />
              Diminta {{ $moment(data.waktu_permintaan_raw).format("DD MMM YYYY HH:mm") }} oleh {{ petugasHapus }}
            </label>
          </div>
          <div v-if="isConfirmed && isApproved" class="approved note_detail">
            <label class="d-block f-14 f-semi m-0">
              Permintaan Disetujui (<span class="f-regular">{{ $moment(data.waktu_konfirmasi_raw).format("DD MMM YYYY HH:mm") }}</span
              >)
            </label>
            <label class="d-block f-c-black f-13 f-regular m-0" v-if="data.keterangan_status">
              <span class="f-c-midgrey">Catatan: </span>{{ data.keterangan_status }}
            </label>
          </div>
          <div v-if="isConfirmed && isDecline" class="decline note_detail">
            <label class="d-block f-14 f-semi m-0">
              Permintaan Ditolak (<span class="f-regular">{{ data.waktu_konfirmasi }}</span
              >)
            </label>
            <label class="d-block f-c-black f-13 f-regular m-0">
              <span class="f-c-midgrey">Alasan: </span>{{ data.keterangan_status }}
            </label>
          </div>
          <div class="card_detail m-t-24">
            <SOCardItem :data="data" :isDetail="true" />
          </div>
          <div class="card_refund">
            <SOCardRefund :data-list="refundList" />
          </div>

          <div class="ket_detail m-t-18">
            <label class="f-14 f-c-midgrey f-regular m-0">Keterangan</label>
            <p class="f-16 f-regular f-c-black">{{ data.keterangan }}</p>
          </div>
          <div>
              <p class="f-regular f-14 f-c-midgrey m-d-4">Dokumentasi</p>
              <div v-if="showImages.length" class="d-flex overflow-auto" style="gap: 12px">
                  <template v-for="(foto, index) in showImages">
                      <img
                          v-if="foto.ref_table === 'transaksi_hapus' || foto.ref_table === 'transaksi_loyalty.req_delete'"
                          :key="index"
                          class="img-view"
                          :src="'https://storage.googleapis.com/' + foto.cloud_bucket + '/' + (foto.cloud_thumb || foto.cloud_name)"
                          alt=""
                          @click="openImage('https://storage.googleapis.com/' + foto.cloud_bucket + '/' + foto.cloud_name, foto.cloud_content_type)"
                      >
                  </template>
              </div>
              <SOImagePreview
                  :modalId="'modalImagePreview-' + data.idtransaksi"
                  ref="img"
              />
          </div>
        </div>
        <div v-if="!isConfirmed && validateAccess('deleteRegular.confirm')" class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0">
          <div class="btn_actions col-md-6 col-sm-6 col-6 pr-0">
            <SOButton :outline="true" :full="true" :text="'Tolak'" :id="`btn_act_tolak${dataId}`" @action="onTolak" />
          </div>
          <div class="btn_actions col-md-6 col-sm-6 col-6 pl-0">
            <SOButton
              :primary="true"
              :full="true"
              :text="'Setujui'"
              :id="`btn_act_terima${dataId}`"
              @action="onTerima"
            />
          </div>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOButton from "@/so-components/global/ui/SOButton";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOCardItem from "../components/SOCardItem.vue";
import SOCardRefund from "../components/SOCardRefund.vue";
import SOImagePreview from '@/so-components/global/ui/SOImagePreview.vue';

import { moduleName } from "../store/state";

export default {
  name: "TransaksiDetail",
  components: {
    SOSlotBase,
    SOLoadingPage,
    SOTitleBar,
    SOCardItem,
    SOCardRefund,
    SOButton,
    SOImagePreview
  },
  data() {
    return {
      backLink: "PembatalanTransaksiReguler.list",
      listRefund: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$route.query.back !== undefined) {
        vm.setBackLink(vm.$route.query.back);
      }

      let haveToReload = ["PembatalanTransaksiReguler.detail.terima", "PembatalanTransaksiReguler.detail.tolak"];
      if (haveToReload.indexOf(from.name) != -1) {
        vm.loadDetail();
      }
    });
  },
  watch: {
    getResponse: function(newRes, oldRes) {
      if (newRes.success) {
        if (this.useToastSuccess && newRes.msg && newRes.msg !== oldRes.msg) {
          this.$toast.success(newRes.msg);
        }
      } else {
        if (newRes.err && newRes.err !== oldRes.err) {
          this.$toast.error(newRes.err);
        }
      }
    },
    data: function(newData, oldData) {
      if (newData.data_refund && newData.data_refund != oldData.data_refund) {
        this.listRefund = newData.data_refund;
      }
    },
  },
  async mounted() {
    await this.loadDetail()
    this.smartTrackingView("detail_penghapusan_transaksi_reguler");

  },
  computed: {
    ...mapGetters(moduleName, {
      isFetching: "isFecthing",
      data: "dataDetail",
      useToastSuccess: "toastSuccess",
      getResponse: "getResponse",
    }),
    dataId() {
      return this.$route.params.id;
    },
    isConfirmed() {
      return this.data.status_penghapusan !== 0;
    },
    isApproved() {
      return this.data.status_penghapusan === 1;
    },
    isDecline() {
      return this.data.status_penghapusan === 2;
    },
    isOwner() {
      return this.data.isrequestkaryawan === 0;
    },
    petugasHapus() {
      return this.isOwner ? `Owner (${this.data.nama_owner})` : this.data.nama_karyawan_transaksi;
    },
    refundList() {
      return this.listRefund;
    },
    showImages(){
        return this.data.transaksi_foto
    },
  },
  methods: {
    back() {
      this.$router.push({ name: this.backLink, query: this.$route.query.oldQuery });
    },
    async loadDetail() {
      await this.$store.dispatch(`${moduleName}/loadDetail`, { id: this.dataId });
    },
    setBackLink(routeBack) {
      this.backLink = routeBack;
    },
    onTolak() {
      this.$router.push({
        name: "PembatalanTransaksiReguler.detail.tolak",
      });
      this.smartTrackingClick("tolak_hapus_transaksi_reguler");

    },
    onTerima() {
      this.$router.push({
        // name: "PembatalanTransaksiReguler.detail.terima",
	    name: "TransaksiDetail",
	    params: {
		  idtransaksi: this.data.idtransaksi
	    },
	    query: {
		  modalOpen: true,
	    }
      });
    },
    openImage(imgUrl, contentType) {
        this.$refs.img.open(imgUrl, contentType)
    },
  },
};
</script>

<style scoped>
.pr-0 {
  padding-right: 7.5px !important;
}

.pl-0 {
  padding-left: 7.5px !important;
}

.fc-yellow {
  color: #eeb711;
}

.btn_action_wrapper {
  position: fixed;
  bottom: 64px;
  background-color: white;
  height: 80px;
}

.note_detail {
  margin-top: 12px;
  padding: 12px 15px;
  margin-left: -15px;
  margin-right: -15px;
}

.approved {
  background: #effaf1;
  color: #40964c;
}

.decline {
  background: #fbf3f3;
  color: #964040;
}

.img-view {
    min-width: 80px;
    min-height: 80px;
    width: 80px;
    height: 80px;
    border: 1px solid #E1E5EC;
    box-sizing: border-box;
    border-radius: 3px;
    object-fit: cover;
}
</style>
